import Link from 'next/link';
import {
  Button,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from '@lb-classroom/ui';
import React, { useEffect, useState } from 'react';
import { WithTranslation } from 'react-i18next';
import { withTranslation } from 'next-i18next';
import { getDateFnsLocale } from '../../../../../../lib/date-utils';
import { format, getHours } from 'date-fns';

interface PassedProps {
  t: any;
  timezone: string;
  currentLocale: string;
}

type Props = WithTranslation & PassedProps;

const TimeMenu: React.FC<Props> = (props: Props) => {
  const [time, setTime] = useState(new Date());
  const [timer, setTimer] = useState(null);
  const { t, timezone, currentLocale } = props;

  const handleSetTime = () => {
    setTime(new Date());
  };

  useEffect(() => {
    const localHandleSetTime = () => {
      setTime(new Date());
    };
    const intervalId = window.setInterval(localHandleSetTime, 1000);
    setTimer(intervalId);
    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  const getFormattedTime = (): string | null => {
    if (!time) return null;

    const locale = getDateFnsLocale(currentLocale);
    const hour = getHours(time);

    if (currentLocale === 'ja') {
      // Japanese locale: AM/PM before time, special handling for noon
      if (hour <= 11) {
        return format(time, 'aaH:mm', { locale });
      } else if (hour === 12) {
        return format(time, "aa'0':mm", { locale });
      } else {
        return format(time, 'aah:mm', { locale });
      }
    } else if (currentLocale === 'tw') {
      // Traditional Chinese: AM/PM before time
      return format(time, 'aah:mm', { locale });
    }

    // Default English format
    return format(time, 'hh:mm a', { locale });
  };

  const formattedTime = getFormattedTime();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="text-default font-medium focus:outline-none">
          {formattedTime}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64 p-0">
        <div className="m-4">
          <div className="timezone-title mb-2">
            {t('service.header.yourTimezone')}
          </div>
          <span className="timezone-body">{timezone}</span>
        </div>
        <div className="change-timezone m-4">
          <Link href="/s/profile/edit">
            <Button>{t('links.resetTimezone')}</Button>
          </Link>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default withTranslation('common')(TimeMenu);
